const postalAddressInputDirective = /* @ngInject */ (
	/** @type {any} */ AddressService,
	/** @type {import('~/scripts/services/model/user').UserModel} */ User,
) => ({
	require:  [
		'ngModel',
		'^postalAddress',
	],
	restrict: 'A',
	scope:    true,
	link:     (
		/** @type {any} */ scope,
		/** @type {any} */ element,
		/** @type {import('angular').IAttributes} */ attributes,
		/** @type {[import('angular').INgModelController, import('./postal-address.controller').default]} */ ctrls,
	) => {
		const [ngModelCtrl, postalAddressCtrl] = ctrls;

		/**
		 * Generates matches array or prepare order for API
		 *
		 * @param {string} inputValue input value
		 */
		const getMatchesAsync = inputValue => {
			postalAddressCtrl.loading = true;
			postalAddressCtrl.query = inputValue;

			// noinspection JSUnresolvedVariable,JSUnresolvedFunction
			const service = new window.google.maps.places.AutocompleteService(); // jshint ignore:line
			service.getPlacePredictions({
				input: inputValue,
				types: [],
			}, (
				results,
				status,
			) => (results ? postalAddressCtrl.displayResults(results, status) : null));
		};

		if (!scope.component) {
			scope.component = {
				key: `K${User.getRef()}`,
			};
		}

		attributes.$observe('disabled', newValue => {
			const mfSuggestionsButton = element.parent().find('.mf-suggestions');
			if (mfSuggestionsButton.length > 0) {
				mfSuggestionsButton.prop('disabled', newValue);
			}
		});

		if (ngModelCtrl) {
			// plug into $parsers pipeline to open a MF on view changes initiated from DOM
			// $parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
			ngModelCtrl.$parsers.unshift(inputValue => {
				postalAddressCtrl.hasFocus = true;

				if (inputValue && inputValue.length > 0) {
					getMatchesAsync(inputValue);
				}
				else {
					postalAddressCtrl.resetMatches();
				}

				return inputValue;
			});

			ngModelCtrl.$formatters.push(modelValue => {
				const Address = AddressService;
				if (!(modelValue instanceof Address.constructor)) {
					// eslint-disable-next-line no-param-reassign
					modelValue = Address.set(modelValue);
				}

				return modelValue.toString();
			});
		}

		element.on('focus', () => {
			postalAddressCtrl.hasFocus = true;
		});

		element.on('blur', () => {
			postalAddressCtrl.hasFocus = false;
		});

		scope.$on('$destroy', () => {
			element.off('focus blur');
		});
	},
});

export default postalAddressInputDirective;
